var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { SvgRegistry } from "survey-core";
import { RadioButtonUncheckedRounded } from "@mui/icons-material";
var SurveyJSIcon = function (_a) {
    var iconNameKey = _a.iconNameKey, isSelected = _a.isSelected, selectedColor = _a.selectedColor;
    var formatSvgContent = function (svgContent) {
        if (!svgContent.includes("<symbol")) {
            return svgContent;
        }
        var viewBoxMatch = svgContent.match(/viewBox="([^"]+)"/);
        var viewBox = viewBoxMatch ? viewBoxMatch[1] : "0 0 24 24";
        var pathMatch = svgContent.match(/<path[^>]*>/);
        var path = pathMatch ? pathMatch[0] : "";
        return "<svg viewBox=\"".concat(viewBox, "\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\">").concat(path, "</svg>");
    };
    if (!SvgRegistry.icons[iconNameKey]) {
        return null;
    }
    return (_jsxs(Box, __assign({ component: "div", sx: {
            width: 54,
            height: 54,
            position: "relative",
        } }, { children: [_jsx(Box, __assign({ sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    color: isSelected ? selectedColor : "#E0E0E0",
                    zIndex: 0,
                } }, { children: _jsx(RadioButtonUncheckedRounded, { sx: { fontSize: 48, width: "100%", height: "100%" } }) })), _jsx(Box, __assign({ sx: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1,
                    color: isSelected ? selectedColor : "action.disabled",
                    "& svg": {
                        width: "24px",
                        height: "24px",
                        fill: isSelected ? selectedColor : "#9e9e9e",
                        display: "block",
                    },
                } }, { children: _jsx("span", { dangerouslySetInnerHTML: {
                        __html: formatSvgContent(SvgRegistry.icons[iconNameKey]),
                    } }) }))] })));
};
export default SurveyJSIcon;
